"use strict";

let idCounter = 0;
export function generateId() {
  idCounter += 1;
  return `pca-bridge-${idCounter}`;
}
export const noopLogger = {
  debug: () => {},
  warn: () => {},
  error: () => {}
};
function isIndexable(x) {
  return typeof x === 'object' && x !== null;
}

/**
 * Shallow equality, one level deep. Used by `BridgeCore.publish` to dedup
 * re-emissions of new-but-content-equal values (e.g., a freshly-built
 * `modalButtons` array whose contents didn't change between renders).
 */
export function shallowEqual(a, b) {
  const sameRef = Object.is(a, b);
  const bothComparableObjects = isIndexable(a) && isIndexable(b) && Array.isArray(a) === Array.isArray(b);
  let result;
  if (sameRef) {
    result = true;
  } else if (!bothComparableObjects) {
    result = false;
  } else {
    const keys = Object.keys(a);
    result = keys.length === Object.keys(b).length && keys.every(k => Object.prototype.hasOwnProperty.call(b, k) && Object.is(a[k], b[k]));
  }
  return result;
}
function isWireEnvelope(parsed) {
  return typeof parsed === 'object' && parsed !== null && 'type' in parsed && typeof parsed.type === 'string' && parsed.type.startsWith('__bridge/') && 'bridgeVersion' in parsed && typeof parsed.bridgeVersion === 'string';
}
export function parseWireEnvelope(rawData) {
  let parsed;
  try {
    parsed = JSON.parse(rawData);
  } catch {
    parsed = null;
  }
  return isWireEnvelope(parsed) ? parsed : null;
}
//# sourceMappingURL=util.js.map